import { render, staticRenderFns } from "./StatsCard.vue?vue&type=template&id=0f216de4"
import script from "./StatsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports